import { useEffect, useState } from 'react';
import './Slots.scss';
import { Slot } from '../types';
import { Loader } from '@/components/Loader/Loader';
import { useTranslation } from 'react-i18next';
export type SlotsProps = {
  slots?: Slot[];
  onSelectSlot: (item: Slot) => void;
  title: string;
  selectedSlot?: Slot;
  isLoading: boolean;
};
export const Slots = ({ slots, onSelectSlot, selectedSlot, isLoading }: SlotsProps) => {
  const { t } = useTranslation();
  const selectSlot = (index: any) => {
    if (slots) {
      onSelectSlot(slots[index]);
    }
  };
  return !isLoading ? (
    <div>
      {slots && slots?.length > 0 ? (
        <div className="slots">
          {slots &&
            slots?.map((slot: Slot, index) => {
              return (
                <div
                  key={index}
                  className={`slot ${selectedSlot && slot.id === selectedSlot.id ? 'active' : ''}`}
                  onClick={() => selectSlot(index)}
                >
                  <div>{slot && slot.label ? slot.label : ''}</div>
                </div>
              );
            })}
          {/* <div className="gradient"></div> */}
        </div>
      ) : (
        <div className="slots">
          <div className="slot">{t('No slots')}</div>
        </div>
      )}
    </div>
  ) : (
    <Loader text="" />
  );
};
